/**
 * The properties used for an access check for a non-object resource.
 */

import { AccessCheckMode } from '../constants/accessCheckMode';

/**
 * A resource reference for an access check. Kept as a plain local shape
 * (rather than importing the generated `EntityBase` union) so that
 * consumers of this library don't need to deal with the `SingleEntity`/
 * `WildcardEntity` discriminated union used on the wire.
 */

// TODO: Temporary for scope-to-gyro-grant transition. Remove ResourceBasedAccessCheckConfig,
// ScopeBasedAccessCheckConfig, and isScopeBasedConfig once migration to gyro grant checks is complete.
export function isScopeBasedConfig(config) {
  return config.mode === AccessCheckMode.SCOPE;
}
export function isNoScopeBasedConfig(config) {
  return config.mode === AccessCheckMode.NO_SCOPE;
}